"use strict";
import { CsvParserFactory } from "./parsers/CsvParserFactory";
export class CsvParserService {
  /**
   * Parse CSV text into a structured object for chart visualization
   * @param csvText The CSV text to parse
   * @param recordType The type of record ('applications' or 'jobs')
   * @returns A structured object with data grouped by month and category
   */
  parseCSV(csvText, recordType = "applications") {
    const parser = CsvParserFactory.createParser(recordType);
    return parser.parseCSV(csvText);
  }
}
export const csvParserService = new CsvParserService();
